/**
 * @ignore
 * Created by shanie on 3/8/17.
 */

/* @flow */

import React from 'react';
import { createRefetchContainer, graphql } from 'react-relay';
import PropTypes from 'prop-types';

// Components
import Heart from './Heart';

// Helpers
import get from 'lodash.get';

// Types
import type { HeartWrapperProps } from './types';

export function HeartWrapper(props: HeartWrapperProps) {
    const heartPortfolioMatches = get(props, 'viewer.heartItemMatches') || [];
    const itemMatches = heartPortfolioMatches.filter(
        heart => get(heart, 'item.serviceId') === props.itemId
    );

    function doRefetch() {
        return new Promise(resolve => {
            props.relay.refetch(
                fragmentVariables => fragmentVariables,
                null,
                () => resolve()
            );
        });
    }

    return <Heart {...props} doRefetch={doRefetch} heartPortfolioItems={itemMatches} />;
}

// ignore default prop functions from coverage stats
/* istanbul ignore next */
HeartWrapper.defaultProps = {
    forceFavoriteItem: false,
    portfolioItemId: '',
    portfolioId: null,
    selectedItemIds: [],
    type: 'outline',
    userId: '',
};

HeartWrapper.propTypes = {
    className: PropTypes.string,
    buttonClass: PropTypes.string,
    authModalShow: PropTypes.func.isRequired,
    forceFavoriteItem: PropTypes.bool,
    itemId: PropTypes.string.isRequired,
    onError: PropTypes.func,
    onFavorited: PropTypes.func,
    onHeartClick: PropTypes.func,
    onUnFavorited: PropTypes.func,
    portfolioId: PropTypes.string,
    relay: PropTypes.object,
    type: PropTypes.oneOf(['outline', 'button']),
    userId: PropTypes.string,
};

export default createRefetchContainer(
    HeartWrapper,
    {
        viewer: graphql`
            fragment HeartWrapper_viewer on Viewer
            @argumentDefinitions(
                selectedItemIds: { type: "[String]", defaultValue: [] }
                loadPortfolioData: { type: "Boolean", defaultValue: false }
                userIds: { type: "[String]", defaultValue: [] }
            ) {
                heartItemMatches: portfolioItemMatches(
                    itemIds: $selectedItemIds
                    userIds: $userIds
                    portfolioTypes: [HEART]
                ) @include(if: $loadPortfolioData) {
                    ...Heart_heartPortfolioItems
                    item {
                        serviceId
                    }
                }
                ...Heart_viewer @arguments(userIds: $userIds, loadPortfolioData: $loadPortfolioData)
            }
        `,
    },
    graphql`
        query HeartWrapperRefetchQuery(
            $selectedItemIds: [String]
            $loadPortfolioData: Boolean!
            $userIds: [String]!
        ) {
            viewer {
                ...HeartWrapper_viewer
                @arguments(
                    selectedItemIds: $selectedItemIds
                    loadPortfolioData: $loadPortfolioData
                    userIds: $userIds
                )
            }
        }
    `
);
